import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@dental-staffing-platform/ui/styles.css';
import { AuthProvider, type AuthConfig } from '@dental-staffing-platform/auth';
import { App } from './App.js';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

const platformApiUrl: string | undefined = import.meta.env.VITE_PLATFORM_API_URL;
if (!platformApiUrl) throw new Error('VITE_PLATFORM_API_URL is required');
const authConfig: AuthConfig = { apiBaseUrl: platformApiUrl };

createRoot(rootEl).render(
  <StrictMode>
    <AuthProvider config={authConfig}>
      <App />
    </AuthProvider>
  </StrictMode>
);
